// extracted by mini-css-extract-plugin
export default {"projects":"Projects_projects__J84UD","projectstitle":"Projects_projectstitle__iQRhw"};